export function SelectAllToggle({
  allIds,
  selectedIds,
  onChange,
  disabled = false,
}: {
  allIds: any[];
  selectedIds: any[];
  onChange: (ids: any[]) => void;
  disabled?: boolean;
}) {
  const selected = new Set((selectedIds || []).map(String));
  const allSelected = allIds.length > 0 && allIds.every((id) => selected.has(String(id)));
  return (
    <button
      type="button"
      className="ms-auto ml-auto border-0 bg-transparent p-0 text-xs font-medium text-primary hover:underline disabled:cursor-not-allowed disabled:opacity-50"
      disabled={disabled || allIds.length === 0}
      onClick={() => onChange(allSelected ? [] : allIds)}
    >
      {allSelected ? 'Clear all' : 'Select all'}
    </button>
  );
}
